module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoice-report-page"
  }, [(!_vm.canSeeReport) ? _c('div', {
    staticClass: "foo"
  }, [_c('h1', [_vm._v(_vm._s(_vm.locale.t('label_invoice_report')))]), _vm._v(" "), _c('div', {
    staticClass: "invoice-report-page__empty"
  }, [_vm._v(_vm._s(_vm.locale.t('label_no_permission_for_report')))])]) : _c('div', {
    staticClass: "foo"
  }, [_c('div', {
    staticClass: "invoice-report-page__head"
  }, [_c('h1', [_vm._v(_vm._s(_vm.locale.t('label_invoice_report')))]), _vm._v(" "), _c('button', {
    staticClass: "new-button",
    on: {
      "click": _vm.openInvoices
    }
  }, [_c('i', {
    staticClass: "ti-arrow-left"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_invoices')) + "\n      ")])]), _vm._v(" "), _c('section', {
    staticClass: "invoice-report-page__filters section-top-xs"
  }, [_c('div', {
    staticClass: "invoice-report-page__filters-grid"
  }, [_c('div', {
    staticClass: "input-group invoice-report-page__date-wrap"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', [_vm._v(_vm._s(_vm.locale.t('label_from')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group invoice-report-page__date-wrap"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', [_vm._v(_vm._s(_vm.locale.t('label_to')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }],
    staticClass: "input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "new-button invoice-report-page__search-btn",
    attrs: {
      "disabled": !_vm.canSearch() || _vm.loading
    },
    on: {
      "click": _vm.clickSearch
    }
  }, [_c('i', {
    staticClass: "ti-search"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_do_search')) + "\n        ")])])]), _vm._v(" "), (_vm.loading) ? _c('section', {
    staticClass: "invoice-report-page__loading"
  }, [_c('div', {
    staticClass: "loader"
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.locale.t('label_loading')))])]) : _vm._e(), _vm._v(" "), (_vm.loaded && !_vm.loading) ? [(_vm.flatInvoices.length) ? _c('section', {
    staticClass: "invoice-report-page__kpi-grid"
  }, [_c('article', {
    staticClass: "invoice-report-page__kpi-card"
  }, [_c('div', {
    staticClass: "invoice-report-page__kpi-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_total_turnover')))]), _vm._v(" "), _c('div', {
    staticClass: "invoice-report-page__kpi-value"
  }, [_vm._v(_vm._s(_vm.formatMoney(_vm.totalTurnover)) + " EUR")])]), _vm._v(" "), _c('article', {
    staticClass: "invoice-report-page__kpi-card"
  }, [_c('div', {
    staticClass: "invoice-report-page__kpi-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_invoices')))]), _vm._v(" "), _c('div', {
    staticClass: "invoice-report-page__kpi-value"
  }, [_vm._v(_vm._s(_vm.totalInvoices))])]), _vm._v(" "), _c('article', {
    staticClass: "invoice-report-page__kpi-card invoice-report-page__kpi-card--danger"
  }, [_c('div', {
    staticClass: "invoice-report-page__kpi-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_debtors')))]), _vm._v(" "), _c('div', {
    staticClass: "invoice-report-page__kpi-value"
  }, [_vm._v(_vm._s(_vm.debtorsList.length))])])]) : _vm._e(), _vm._v(" "), (_vm.flatInvoices.length) ? _c('section', {
    staticClass: "invoice-report-page__charts section-top-xs"
  }, [_c('article', {
    staticClass: "invoice-report-page__chart-card"
  }, [_c('header', {
    staticClass: "invoice-report-page__chart-head"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_monthly_turnover')))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("EUR")])]), _vm._v(" "), _c('div', {
    staticClass: "invoice-report-page__rows"
  }, _vm._l((_vm.monthlyChartData), function(item) {
    return _c('div', {
      key: 'm-' + item.key,
      staticClass: "invoice-report-page__row"
    }, [_c('div', {
      staticClass: "invoice-report-page__label",
      attrs: {
        "title": item.label
      }
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "invoice-report-page__bar-wrap"
    }, [_c('div', {
      staticClass: "invoice-report-page__bar invoice-report-page__bar--monthly",
      style: ({
        width: _vm.chartWidth(item.value, _vm.maxMonthlyValue)
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "invoice-report-page__value"
    }, [_vm._v(_vm._s(_vm.formatMoney(item.value)))])])
  }), 0)]), _vm._v(" "), _c('article', {
    staticClass: "invoice-report-page__chart-card"
  }, [_c('header', {
    staticClass: "invoice-report-page__chart-head"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_turnover_by_company')))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("EUR")])]), _vm._v(" "), _c('div', {
    staticClass: "invoice-report-page__rows"
  }, _vm._l((_vm.companyChartData), function(item) {
    return _c('div', {
      key: 'c-' + item.label,
      staticClass: "invoice-report-page__row"
    }, [_c('div', {
      staticClass: "invoice-report-page__label",
      attrs: {
        "title": item.label
      }
    }, [_vm._v(_vm._s(_vm.shortLabel(item.label, 26)))]), _vm._v(" "), _c('div', {
      staticClass: "invoice-report-page__bar-wrap"
    }, [_c('div', {
      staticClass: "invoice-report-page__bar invoice-report-page__bar--company",
      style: ({
        width: _vm.chartWidth(item.value, _vm.maxCompanyValue)
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "invoice-report-page__value"
    }, [_vm._v(_vm._s(_vm.formatMoney(item.value)))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.debtorsList.length) ? _c('section', {
    staticClass: "invoice-report-page__table-wrap section-top-xs"
  }, [_c('header', {
    staticClass: "invoice-report-page__chart-head"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_debtors_list')))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.locale.t('label_paid_no')))])]), _vm._v(" "), _c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.locale.t('label_company')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_from')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_to')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_created')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.locale.t('label_amount')) + " EUR")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.debtorsList), function(item) {
    return _c('tr', {
      key: 'd-' + item.id
    }, [_c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_company')
      }
    }, [_vm._v(_vm._s(item.company))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_from')
      }
    }, [_vm._v(_vm._s(_vm.formatDate(item.fromPeriod)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_to')
      }
    }, [_vm._v(_vm._s(_vm.formatDate(item.toPeriod)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_created')
      }
    }, [_vm._v(_vm._s(_vm.formatDate(item.createdTime)))]), _vm._v(" "), _c('td', {
      staticClass: "invoice-report-page__amount-red",
      attrs: {
        "data-title": _vm.locale.t('label_amount') + ' EUR'
      }
    }, [_vm._v(_vm._s(_vm.formatMoney(item.amount)))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.flatInvoices.length) ? _c('section', {
    staticClass: "invoice-report-page__empty"
  }, [_vm._v("\n        😐 " + _vm._s(_vm.locale.t('label_no_minus_invoices_for_period')) + "\n      ")]) : _vm._e()] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-600bd398!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Invoice/InvoiceReport.vue
// module id = 773
// module chunks = 0